'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className"];
/**
 * Lead Circle logo
 *
 * Renders the Lead Circle logo
 */
var LogoLeadCircle = react.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    rest = _objectWithoutProperties__default["default"](_ref, _excluded);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.svg, _extends__default["default"]({
    __css: {
      w: '100%',
      h: '100%'
    },
    role: "img",
    className: utils.cx('chakra-logo-lead-circle', className)
  }, rest, {
    viewBox: "0 0 3179.81 207.64",
    ref: ref
  }), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__a",
    y1: 104.28,
    x2: 202.99,
    y2: 104.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default["default"].createElement("stop", {
    offset: 0,
    stopColor: "#1992f4"
  }), /*#__PURE__*/React__default["default"].createElement("stop", {
    offset: 1,
    stopColor: "#2b8af6"
  })), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__b",
    x1: 2193.18,
    y1: 153.89,
    x2: 2266.87,
    y2: 153.89,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__c",
    x1: 2274.68,
    y1: 153.89,
    x2: 2359.89,
    y2: 153.89,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__d",
    x1: 2410.87,
    y1: 153.89,
    x2: 2491.94,
    y2: 153.89,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__e",
    x1: 2505.44,
    y1: 153.68,
    x2: 2600.64,
    y2: 153.68,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__f",
    x1: 2613.3,
    y1: 154.59,
    x2: 2694.79,
    y2: 154.59,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__g",
    x1: 2714.55,
    y1: 153.85,
    x2: 2780.36,
    y2: 153.85,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__h",
    x1: 2795.2,
    y1: 153.85,
    x2: 2880.14,
    y2: 153.85,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__i",
    x1: 2899.75,
    y1: 153.78,
    x2: 2996.08,
    y2: 153.78,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__j",
    x1: 3018.16,
    y1: 153.89,
    x2: 3078.49,
    y2: 153.89,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__k",
    x1: 3096.21,
    y1: 153.89,
    x2: 3179.81,
    y2: 153.89,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__l",
    x1: 276.68,
    y1: 104.11,
    x2: 402.54,
    y2: 104.11,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__m",
    x1: 426.61,
    y1: 104.11,
    x2: 555.95,
    y2: 104.11,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__n",
    x1: 575.09,
    y1: 102.8,
    x2: 780.41,
    y2: 102.8,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__o",
    x1: 807.09,
    y1: 104.11,
    x2: 982.82,
    y2: 104.11,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__p",
    x1: 1054.99,
    y1: 103.96,
    x2: 1255.37,
    y2: 103.96,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__q",
    x1: 1272.48,
    y1: 104.11,
    x2: 1375.43,
    y2: 104.11,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__r",
    x1: 1409.07,
    y1: 104.11,
    x2: 1580.74,
    y2: 104.11,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__s",
    x1: 1599.89,
    y1: 103.96,
    x2: 1800.27,
    y2: 103.96,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__t",
    x1: 1833.91,
    y1: 104.11,
    x2: 1959.77,
    y2: 104.11,
    xlinkHref: "#leadcircle_svg__a"
  }), /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    id: "leadcircle_svg__u",
    x1: 1989.65,
    y1: 104.11,
    x2: 2118.98,
    y2: 104.11,
    xlinkHref: "#leadcircle_svg__a"
  })), /*#__PURE__*/React__default["default"].createElement("rect", {
    y: 2.78,
    width: 202.99,
    height: 202.99,
    rx: 15.15,
    fill: "url(#leadcircle_svg__a)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M163.37 159.74l-14.16-41.64c-.33-1-.52-1.18-1.35-.25-3.11 3.5-6.27 7-9.53 10.31a179.89 179.89 0 01-18.63 16.23 194.56 194.56 0 01-22 15.5c-2.54 1.47-5.1 2.92-7.66 4.38l.12.27h73.34c1 .1 1.4-.13 1-1.22s-.73-2.4-1.13-3.58z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M122.83 63c-3.59-5.61-7.45-11-12.68-15.24-4-3.21-8.32-5-13.49-3.34a23.23 23.23 0 00-8.79 5.63 66.36 66.36 0 00-10.39 13.17c-8 12.73-14.13 26.4-19.37 40.44-4.62 12.38-8.86 24.91-13 37.46-2.47 7.45-4.42 15.06-6.64 22.59-.26.89 0 1.06.79 1 1.52-.05 3 0 4.56 0h2.87c1.24 0 2.45.14 3.62-.68 9.21-6.48 18.6-12.73 27.68-19.4a400 400 0 0037.54-31.49 249.55 249.55 0 0020.84-22 1.64 1.64 0 00.25-2A225.64 225.64 0 00122.83 63z",
    fill: "#f2686d"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2245.85 151.43v-.7q8.71-1.54 13.36-7.53t4.64-15q0-13.36-9.46-19.55t-30.69-6.19h-30.52v102.8h37.13q17.22 0 26.89-7.84t9.67-21.69q0-10.27-5.1-16.28t-15.92-8.02zM2210 116.55h14.55q11.4 0 16.63 3.24t5.24 10.48q0 8-4.85 11.35t-15.4 3.34H2210zm33.78 70.56q-5.37 4-15.92 4H2210V158.6h17q11.19 0 16.67 3.87t5.48 11.88q0 8.72-5.38 12.76z",
    fill: "url(#leadcircle_svg__b)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fill: "url(#leadcircle_svg__c)",
    d: "M2317.29 149.39l-24.33-46.9h-18.28l34.1 63.49v39.31h16.87v-39.87l34.24-62.93h-18.28l-24.32 46.9z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fill: "url(#leadcircle_svg__d)",
    d: "M2475.07 144.54h-47.39v-42.05h-16.81v102.8h16.81v-46.34h47.39v46.34h16.87v-102.8h-16.87v42.05z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2543.9 102.07l-38.46 103.22h17.72l10.06-28.55h39.3l10.27 28.55h17.85l-38.46-103.22zm-5.76 60.19l9.28-26.79a158 158 0 005.55-18.92q.71 2.82 2.57 8.86t2.92 8.86l9.63 28z",
    fill: "url(#leadcircle_svg__e)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2678 167.39q0 25-23.77 25-12.22 0-18.14-6t-5.9-18.77v-65h-16.89v66.24q0 17.72 10.62 27.84t29.74 10.12q12.87 0 22.11-4.6a32.53 32.53 0 0014.14-13.15 39.51 39.51 0 004.88-19.93v-66.65H2678z",
    fill: "url(#leadcircle_svg__f)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2770.17 156.07q-5.28-4.08-16.6-8.79-10.05-4.14-13.92-6.68a17.16 17.16 0 01-5.55-5.38 13.16 13.16 0 01-1.69-6.85 11.68 11.68 0 014.22-9.39q4.22-3.56 12.37-3.55 10.77 0 24.47 5.76l5.35-13.71a72.14 72.14 0 00-29.39-6.46q-15.41 0-24.54 7.38t-9.14 20.25a27.56 27.56 0 005.76 17.58q5.76 7.31 19.83 13 13.63 5.49 18 9.5a12.76 12.76 0 014.36 9.77 12.35 12.35 0 01-4.75 10.19q-4.74 3.81-14.73 3.8a63.21 63.21 0 01-14.73-1.9 76.87 76.87 0 01-14.94-5.2v15.89q11.11 5.41 28.55 5.41t27.35-7.8q9.91-7.8 9.91-21.52a27.69 27.69 0 00-2.46-12.09 25.91 25.91 0 00-7.73-9.21z",
    fill: "url(#leadcircle_svg__g)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2842.31 163.94h21.3v26.51a81.36 81.36 0 01-17.43 2q-16.18 0-24.79-9.81t-8.61-28.64q0-17.92 9.56-28.26t26-10.34a59.46 59.46 0 0125 5.76l5.9-14a76.62 76.62 0 00-30.51-6.18q-25 0-39.31 14t-14.27 38.85q0 25.17 12.66 39t36 13.81a126.58 126.58 0 0018.45-1.26 108.65 108.65 0 0017.83-4.29v-51.56h-37.83z",
    fill: "url(#leadcircle_svg__h)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2948.13 100.87q-23.28 0-35.82 13.65t-12.56 39.09q0 25.45 12.48 39.27t35.77 13.81q23 0 35.54-13.92t12.55-39q0-25.17-12.51-39t-35.45-13.9zm22.46 81.78q-7.62 9.71-22.6 9.7t-22.71-9.81q-7.67-9.81-7.67-28.79t7.7-28.69q7.71-9.77 22.82-9.77t22.53 9.77q7.56 9.78 7.56 28.69 0 19.25-7.63 28.9z",
    fill: "url(#leadcircle_svg__i)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fill: "url(#leadcircle_svg__j)",
    d: "M3034.97 102.49h-16.81v102.8h60.33v-14.41h-43.52v-88.39z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3166.17 115.71q-13.65-13.21-38.18-13.22h-31.78v102.8H3125q26.57 0 40.71-13.47t14.13-38.91q-.03-23.99-13.67-37.2zM3125 191.16h-12v-74.61h14.56q34.51 0 34.52 36.92.01 37.7-37.08 37.69z",
    fill: "url(#leadcircle_svg__k)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M328.88 2.61h-52.2v203h125.86v-46.69h-73.66z",
    fill: "url(#leadcircle_svg__l)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M478.23 123.83h69V77.72h-69V49h75.11V2.61H426.61v203H556V159.5h-77.77z",
    fill: "url(#leadcircle_svg__m)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M666.44 0l-91.35 198.07v7.54h50.75l11.89-25.52h80l11.89 25.52h50.75v-7.54L688.77 0zm-11.6 135.43l22.62-53.36 23.2 53.36z",
    fill: "url(#leadcircle_svg__n)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M883.64 2.61h-76.55v203h76.55c132.24-.61 132.24-202.42 0-203zm0 155.73H859V49.88h24.64c64.67 0 64.67 108.46 0 108.46z",
    fill: "url(#leadcircle_svg__o)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1159.09 160.37c-30.74-.29-50.46-26.39-50.46-56.26 0-33.64 20-56.55 50.46-56.55 21.75 0 37.12 9.28 44.37 29.87h51C1246.67 23.2 1201.14.29 1159.09.29c-51.62 0-103.81 34.8-104.1 103.82.29 69 52.48 103.82 104.1 103.53 43.21 0 88.74-22.62 96.28-80h-51c-5.55 21.71-23.24 32.73-45.28 32.73z",
    fill: "url(#leadcircle_svg__p)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1349.62 47.85h23.78V2.61h-98.89v45.24h23.78v112.23h-25.81v45.53h103v-45.53h-25.81z",
    fill: "url(#leadcircle_svg__q)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1498.1 2.61h-89v203h51.9v-59.74h27l34.8 59.74h58v-7.54l-39.8-64.38c51.34-34.8 36.85-130.79-42.9-131.08zm0 96.57H1461V49c12.18 0 24.94-.29 37.12 0 29.56.3 28.11 50.18-.02 50.18z",
    fill: "url(#leadcircle_svg__r)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1704 160.37c-30.74-.29-50.46-26.39-50.46-56.26 0-33.64 20-56.55 50.46-56.55 21.75 0 37.12 9.28 44.37 29.87h51C1791.57 23.2 1746 .29 1704 .29c-51.62 0-103.81 34.8-104.1 103.82.29 69 52.48 103.82 104.1 103.53 43.21 0 88.74-22.62 96.28-80h-51c-5.56 21.71-23.28 32.73-45.28 32.73z",
    fill: "url(#leadcircle_svg__s)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1886.11 2.61h-52.2v203h125.86v-46.69h-73.66z",
    fill: "url(#leadcircle_svg__t)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2041.26 123.83h69V77.72h-69V49h75.11V2.61h-126.72v203H2119V159.5h-77.72z",
    fill: "url(#leadcircle_svg__u)"
  }));
});
LogoLeadCircle.displayName = 'LogoLeadCircle';
exports.LogoLeadCircle = LogoLeadCircle;